import React, { useState, Dispatch } from 'react';
import { myProfileService } from '@app/services';
import { TwoFactorPush } from '@app/modules/mfaToken/components';
import { loginForms } from '@app/enums';
import { useTypedTranslation } from '@app/hooks';
import { MfaTestSuccess } from './';

interface IProps {
    setLoginForm: Dispatch<loginForms>;
    isMultipleProviders: boolean;
}

export function PushTest({ setLoginForm, isMultipleProviders }: IProps) {
    const { translation } = useTypedTranslation();
    const [isSuccess, setIsSuccess] = useState<boolean>(false);

    const cbAfterMount = () =>
        myProfileService.testPush().then(({ data }) => {
            if (data.success) {
                setIsSuccess(true);
            }
            else {
                return data;
            }
        });

    return isSuccess ? (
        <MfaTestSuccess
            setIsSuccess={setIsSuccess}
            textSuccess={translation('MFA_PUSH_VERIFICATION_SUCCESS_DESC_TEST')}
        />
    ) : (
        <TwoFactorPush
            cbAfterMount={cbAfterMount}
            setLoginForm={setLoginForm}
            isMultipleProviders={isMultipleProviders}
        />
    );
}
